import React, { useState } from "react";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import AllMeetingsContainer from "./AllMeetingsContainer";
import MyMeetingsContainer from "./MyMeetingsContainer";
import MeetingsTabsView, { MeetingsTabKey } from "../ui/MeetingsTabsView";
import RootStackParamList from "../../../navigation/RootStackParamList";

export default function MeetingsTabsContainer() {
  const [activeTab, setActiveTab] = useState<MeetingsTabKey>("AllMeetings");
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  return (
    <MeetingsTabsView
      activeTab={activeTab}
      onChangeTab={setActiveTab}
      onPressCreateMeeting={() => navigation.navigate("Schedule")}
      onPressConversationStarters={() =>
        navigation.navigate("ConversationStarters")
      }
      renderAllMeetings={<AllMeetingsContainer />}
      renderMyMeetings={<MyMeetingsContainer />}
    />
  );
}
